import { createSelector } from 'reselect';
import { initialState } from './reducer';
import { initialState as patchworkInitialState } from '../../containers/StructureBuilderPage/reducer';
import { NotificationPatchFilter } from '../../utils/notificationPatchFilter';
import { viewStates } from '../../containers/StructureBuilderPage/constants';
/**
 * Direct selector to the pushNotifications state domain
 */
export var selectPushNotificationsDomain = function (state) {
    return state.pushNotifications || initialState;
};
export var selectAppPatchworkDomain = function (state) {
    return state.patchwork || patchworkInitialState;
};
export var selectAppPatches = function (state) {
    var _a, _b, _c;
    return ((_b = (_a = state.patchwork) === null || _a === void 0 ? void 0 : _a.patchwork) === null || _b === void 0 ? void 0 : _b.patches) ||
        ((_c = patchworkInitialState === null || patchworkInitialState === void 0 ? void 0 : patchworkInitialState.patchwork) === null || _c === void 0 ? void 0 : _c.patches);
};
export var selectAllDatasets = createSelector(selectAppPatchworkDomain, function (patchwork) { return patchwork.datasets; });
export var selectDatasetsById = function (datasetId) {
    return createSelector(selectAppPatchworkDomain, function (patchwork) { var _a; return (_a = patchwork.datasets) === null || _a === void 0 ? void 0 : _a.find(function (ds) { return (ds === null || ds === void 0 ? void 0 : ds.id) === datasetId; }); });
};
export var selectPatchworkById = function (patchId) {
    return createSelector(selectAppPatchworkDomain, function (patchwork) { var _a, _b; return (_b = (_a = patchwork.patchwork) === null || _a === void 0 ? void 0 : _a.patches) === null || _b === void 0 ? void 0 : _b.find(function (pw) { return (pw === null || pw === void 0 ? void 0 : pw.id) === patchId; }); });
};
export var selectDatasetsLoading = createSelector(selectAppPatchworkDomain, function (patchwork) { return patchwork.datasets_loading; });
export var makeSelectPushNotifications = createSelector(selectPushNotificationsDomain, function (domain) { return domain.pushNotifications; });
var selectPatchwork = createSelector(selectAppPatchworkDomain, function (domain) {
    var patchwork = domain.patchwork;
    if (patchwork && patchwork.patches && patchwork.edges) {
        return patchwork;
    }
    return { patches: [], edges: [] };
});
/**
 * If the entry patch is a list or a view, only the entry patch should appear in the option list
 * If the entry patch is a main menu, all patches that are connected directly or indirectly should appear in the option list
 */
export var selectPatchesDropDown = createSelector(selectPatchwork, function (patchwork) {
    var patchFilter = new NotificationPatchFilter(patchwork);
    return patchFilter.getOptions();
});
export var selectGroupList = createSelector(selectAppPatchworkDomain, function (patchwork) {
    var _a = patchwork.groups, groups = _a === void 0 ? [] : _a;
    return groups;
});
export var selectPatchworkLoading = createSelector(selectAppPatchworkDomain, function (domain) {
    return domain.viewState === viewStates.loading;
});
